export const ENDPOINTS = {
  bulkValidateOpenings:
    '/gateway/extranet/:id/rooms/:roomId/bulk-openings/validate',
  bulkSaveOpenings: '/gateway/extranet/:id/rooms/:roomId/bulk-openings',
  saveRoomBeds: '/gateway/extranet/:id/rooms/beds',
} as const;

export const CORE_QUERY_KEYS = {
  bulkSaveOpenings: 'extranet-bulk-openings',
} as const;
